import React, { useState, useEffect, useRef } from "react";
import {
  Row,
  Col,
  Table,
  Input,
  Button,
  ButtonGroup,
  UncontrolledDropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Tooltip,
} from "reactstrap";
import ColumnFilters from "./components/ColumnFilters";
import Loader from "components/Loader";
import crossIcon from "assets/icon/cross.png";
import searchIcon from "assets/icon/search.png";
import leftArrowIcon from "assets/icon/cps-left-arrow.svg";
import rightArrowIcon from "assets/icon/cps-right-arrow.svg";
import Pagination from "components/Pagination";
import { find } from "lodash";
import ToolTip from "react-tooltip-lite";
import ExportIcon from "assets/icon/Download-Icon3.svg";
import { Dropdown } from "react-bootstrap";
import threedots from "assets/icon/threedots-icon.svg";
import SortDown from "../../assets/icon/Sort_Down.svg";

let keysName = [];
let columnChangedFilters = [];
let isHaveColFilter = false;
const ReactStrapTable = ({
  datafilter,
  id,
  columns,
  data,
  fixedColumn,
  handleSort = () => "",
  loading,
  reset,
  loader,
  hasScrollArrow = true,
  onFilterCancel = () => "",
  onSearchColumnFilters = () => "",
  pageSize,
  onPageSizeChange = () => "",
  children,
  onExport,
  AllExport,
  slelectedExport,
  onSelectColoums,
  hasPagination,
  onPageChange,
  currentPage,
  totalRecords,
  filters,
  researchNeededCount = 0,
  eligibleCount = 0,
  inEligibleCount = 0,
  hasNoEligibility = true,
  hasExportPermission = true,
  gridMsg = "No record found",
  hasColselect = false,
  autoselectlist1,
  toggleSider,
  collapseSider,
  showtoggle,
  claims,
  onManualbulkUpdate,
  resetFlag,
  SetResetFlag
}) => {
  console.log(filters, "filters")
  const [key, setKey] = useState("");
  const [resetField, setResetField] = useState(false);
  const [hasVisibleScrollArrow, setVisibleScrollArrow] = useState(false);
  const [hasLeftArrow, setLeftArrow] = useState(false);
  const [hasRightArrow, setRightArrow] = useState(false);
  const [rSelected, setRSelected] = useState("off");
  const [colFilterEnable, setColFilterEnable] = useState(false);
  const [sortKey, setSortKey] = useState("desc");
  const selectRef = useRef(null);

  // useEffect(() => {
  //   columnChangedFilters = [];
  // }, []);
  const getUpdateColum = () => {
    const updateCol = [];
    const col = columns[0];
    if (!col?.action && colFilterEnable) {
      updateCol.push({
        dataField: "Options",
        text: "Options",
        width: 80,
        show: false,
        disabled: true,
        hideColFilter: true,
        action: true,
      });
    }
    return [...updateCol, ...columns];
  };
  useEffect(() => {
    setKey("");
  }, [reset]);
  console.log(filters);

  useEffect(() => {
    setSortKey('desc');
    keysName = []
    
     if(isHaveColFilter==true){
     onCancelFilter("off")  // this line is for the to controll the api call when ever the new module opens
     }
  }, [id]);

  const removeSort = (keys) => {
    keysName.push(keys);
    const filter = keysName.filter((item) => item === keys);
    if (filter.length === 3) {
      setKey("");
      setSortKey("desc");
      keysName = [];
    } else {
      const sortObj = {
        order: sortKey === "desc" ? "asc" : "desc",
        orderBy: keys,
      };
      setSortKey(sortObj.order);
      if (isHaveColFilter) {
        const apiFilter = {
          ...filters,
          ...sortObj,
          filters: [...columnChangedFilters],
        };
        // handleSort(filters, keys === "claimStatus" ? "claimID" : keys, true, columnChangedFilters);
        handleSort(apiFilter, true);
      } else {
        const apiFilter = { ...filters, ...sortObj };
        // handleSort(filters, keys === "claimStatus" ? "claimID" : keys);
        handleSort(apiFilter);
      }
    }
  };

  const onColHeaderClick = (col) => {
    if (col.disabled) return;
    if(data.length==0){
      return;
    }
    setKey(col.dataField);
    removeSort(col.dataField);
  };
  useEffect(() => {
    if (resetFlag == true) {
      SetResetFlag(false);
      onClickFilter("off");
      setKey("")
      setSortKey("desc")
      keysName=[]
    }
  }, [resetFlag])

  const headerRenderer = () => {
    const cols = getUpdateColum().map((col, index) => {
      if (col.text !== "Drug Cost 340B") {
        return (
          // <th
          //   key={col.dataField}
          //   className={
          //     key === col.dataField
          //       ? `active-sorting-${sortKey === "asc" ? "down" : "up"}`
          //       : ""
          //   }
          //   width={col.width || 100}
          //   onClick={() => {
          //     col.sort ? onColHeaderClick(col) : "";
          //   }}
          //   hidden={!col.show}
          // >
          //   {col.text}
          // </th>
          <th
            key={col.dataField}
            className={
              key === col.dataField
                ? `active-sorting-${sortKey === "asc" ? "down" : "up"}`
                : ""
            }
            width={col.width || 100}
            onClick={() => {
              col.sort ? onColHeaderClick(col) : "";
            }}
            hidden={!col.show}
          >
            <div className="d-flex justify-content-between align-items-center">
              <div
                //  style={{ width: keysName.length>=1?col.width - 17 :""}}
                className=""
              >
                {col.text}
              </div>

              {col.sort == true && sortKey == "desc" && keysName.length == 0 ? (
                <span
                  className=""
                  style={{
                    marginLeft: "8px",
                    position: "relative",
                    verticalAlign: "sub",
                    marginTop: "7px",
                  }}
                >
                  <img
                    src={SortDown}
                    alt=""
                  //  onClick={() => {
                  //    col.sort ? onColHeaderClickTop(col) : '';
                  // }}
                  />
                  <img
                    className="filters_col"
                    src={SortDown}
                    alt=""
                  // onClick={() => {
                  //   col.sort ? onColHeaderClickDown(col) : '';
                  // }}
                  />
                </span>
              ) : (
                ""
              )}
            </div>
            {/* {col.text} */}
          </th>
        );
      } else {
        return (
          <th
            key={col.dataField}
            className={
              key === col.dataField
                ? `active-sorting-${sortKey === "asc" ? "down" : "up"}`
                : ""
            }
            width={col.width || 100}
            onClick={() => {
              col.sort ? onColHeaderClick(col) : "";
            }}
            hidden={!col.show}
          >
            <div className="d-flex justify-content-between align-items-center">
              <div
                style={{ width: col.width - 17 }}
                className=""
              >
                <ToolTip
                  content={
                    <div className="tip-list-info">
                      <p>
                        <span>
                          This represents the actual replenished drug cost
                          calculated once the replenishment has been received.
                          Before that, the cost is only an estimate.{" "}
                        </span>
                      </p>
                    </div>
                  }
                  direction="down"
                  tagName="span"
                  className="target"
                  tipContentClassName=""
                >
                  <span className="cursor-pointer text-decoration">{col.text}</span>
                </ToolTip>
              </div>

              {col.sort == true && sortKey == "desc" && keysName.length == 0 ? (
                <span
                  className=""
                  style={{
                    marginLeft: "8px",
                    position: "relative",
                    verticalAlign: "sub",
                    marginTop: "7px",
                  }}
                >
                  <img
                    src={SortDown}
                    alt=""
                  //  onClick={() => {
                  //    col.sort ? onColHeaderClickTop(col) : '';
                  // }}
                  />
                  <img
                    className="filters_col"
                    src={SortDown}
                    alt=""
                  // onClick={() => {
                  //   col.sort ? onColHeaderClickDown(col) : '';
                  // }}
                  />
                </span>
              ) : (
                ""
              )}
            </div>

          </th>
        );
      }
    });

    return (
      <thead key="headerrow">
        <tr>
          {/* {colFilterEnable && columns[0].action ? <th width={100}>Options</th> : ""} */}
          {cols}

          {/* {colFilterEnable && <th width={100}>Options</th>} */}
        </tr>
      </thead>
    );
  };

  const renderRow = () => {
    if (data.length) {
      const rows = data.map((row, index) => {
        const rowItem = getUpdateColum().map((col) => {
          // if (index === 0 && colFilterEnable) {
          //   return <th key="option" width={100}></th>;
          // }
          if (col.cellRenderer) {
            return (
              <td

                portalId="root portal"
                key={col.dataField}
                width={col.width || 100}
                className={col.edit ? "py-1" : col.className || ""}
                hidden={col.show == false}
              >
                {col.cellRenderer(row, col)}
              </td>
            );
          }
          return (
            <td key={col.dataField} width={col.width || 100} hidden={!col.show}>
              {row[col.dataField]}
            </td>
          );
        });
        return (
          <tr key={index} className="table-striped">
            {" "}
            {rowItem}
            {/* {colFilterEnable && <td width={100}></td>} */}
          </tr>
        );
      });
      return rows;
    } else {
      return (
        <tr>
          <td colSpan={getUpdateColum().length} className="text-center">
            {loading ? "Loading..." : gridMsg}
          </td>
        </tr>
      );
    }
  };

  const handleColumnFilterChange = (
    { target: { value } },
    col,
    type,
    filterType
  ) => {
    const { dataField } = col;
    const obj = {
      filterName: dataField,
      filterType: filterType === "" ? 1 : filterType,
    };
    if (!value) {
      const filter = columnChangedFilters?.filter(
        (item) => item.filterName !== dataField
      );
      columnChangedFilters = filter;
      return;
    }
    const findObj = find(columnChangedFilters, {
      filterName: dataField,
    });
    if (findObj) {
      if (type === "field") {
        findObj.filterValue = value;
      } else {
        findObj.filterType = parseInt(value);
      }
    } else {
      if (type === "field") {
        obj.filterValue = value;
      } else {
        obj.filterType = parseInt(value);
      }
      const colFilters = [...columnChangedFilters, ...[obj]].filter(
        (item) => item.filterValue
      );
      columnChangedFilters = colFilters;
    }
  };

  const onSearchFilter = () => {
    isHaveColFilter = true;
    onSearchColumnFilters(columnChangedFilters);
  };

  const onCancelFilter = () => {
    isHaveColFilter = false;
    onFilterCancel();
    setResetField((pre) => !pre);
    columnChangedFilters = [];
    // this 3 are for the when we click on the sorting and the clcik on the cancel filter to remove the sorting we are adding
    // setSortKey("desc")
    // keysName=[]
    // setKey("")
  };

  const columnFilters = () => {
    var ids = [];
    if (hasColselect) {
      if (autoselectlist1.length > 0)
        for (var x in autoselectlist1) {
          ids.push(autoselectlist1[x].text);
        }
    }

    return (
      <tr
        // style={{ position: "sticky", top: "50px", zIndex:"9"}} 
        className="filter_tdfixed">
        {getUpdateColum()?.map((col, index) => {
          if (index === 0) {
            return (
              <td key="action">
                <span className="pe-2 cursor-pointer" onClick={onSearchFilter}>
                  <img src={searchIcon} alt="" />
                </span>
                <span className="cursor-pointer" onClick={onCancelFilter}>
                  <img src={crossIcon} alt="" />
                </span>
              </td>
            );
          }
          if (col.hideColFilter) {
            return <td key={col.dataField}></td>;
          }
          return (
            <td
              key={col.dataField}
              hidden={
                hasColselect
                  ? autoselectlist1.length > 0
                    ? !ids.includes(col.text)
                    : false
                  : false
              }
            >
              <ColumnFilters
                col={col}
                onColumnFilterChange={handleColumnFilterChange}
                reset={resetField}
              />
            </td>
          );
        })}
      </tr>
    );
  };

  const getCurrentTableElement = () =>
    document
      .querySelector(`#${id}`)
      .getElementsByClassName("table-responsive")[0];

  const handleMouseEnter = () => {
    if (!id) return;
    const element = getCurrentTableElement();
    const rightScroll =
      element.scrollWidth - element.scrollLeft - element.clientWidth;
    if (rightScroll <= 10 && element.scrollLeft <= 10) return;
    if (element.scrollLeft <= 0) {
      setLeftArrow(false);
      setRightArrow(true);
    } else {
      setLeftArrow(true);
    }
    if (rightScroll <= 0) {
      setLeftArrow(true);
      setRightArrow(false);
    }
    setVisibleScrollArrow(true);
  };

  const handleMouseLeave = () => {
    setVisibleScrollArrow(false);
  };

  const scroll = (direction) => {
    const element = getCurrentTableElement();
    slideScroll(element, direction, 50, 500, 70);
  };

  const slideScroll = (element, direction, speed, distance, step) => {
    let scrollAmount = 0;
    var slideTimer = setInterval(function () {
      element.behavior = "smooth";
      if (direction == "left") {
        element.scrollLeft -= step;
      } else {
        element.scrollLeft += step;
      }
      scrollAmount += step;
      if (scrollAmount >= distance) {
        window.clearInterval(slideTimer);
      }
    }, speed);

    setTimeout(() => {
      const el = getCurrentTableElement();
      const rightScroll = el.scrollWidth - el.scrollLeft - el.clientWidth;
      if (el.scrollLeft === 0) {
        setLeftArrow(false);
      } else {
        setLeftArrow(true);
      }
      if (rightScroll <= 0) {
        setRightArrow(false);
      } else {
        setRightArrow(true);
      }
    }, 500);
  };

  const renderScrollArrowButtons = () => {
    if (hasScrollArrow && hasVisibleScrollArrow && data && data.length) {
      return (
        <>
          {hasLeftArrow && (
            <Button
              onClick={() => scroll("left")}
              color="link"
              className={`left-table-button ${!hasLeftArrow ? "opacity-25" : ""
                }`}
              disabled={!hasLeftArrow}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <img
                src={leftArrowIcon}
                alt="leftArrowIcon"
                height={32}
                width={32}
              />
            </Button>
          )}
          {hasRightArrow && (
            <Button
              onClick={() => scroll("right")}
              color="link"
              className={`right-table-button ${!hasRightArrow ? "opacity-25" : ""
                }`}
              disabled={!hasRightArrow}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <img
                src={rightArrowIcon}
                alt="rightArrowIcon"
                height={32}
                width={32}
              />
            </Button>
          )}
        </>
      );
    }
    return null;
  };

  const onClickFilter = (value) => {
    if (value === "on") {
      setRSelected(value);
      setColFilterEnable(true);
    } else {
      setRSelected(value);
      setColFilterEnable(false);
      if (!resetFlag) {
        onCancelFilter();
      }
    }
    columnChangedFilters = [];
  };
  const onHandlePageChange = (page) => {
    
    const pageFilter = { ...filters, currentPage: page ,pageSize:pageSize,
      order:sortKey,orderBy:key?key:filters?.orderBy?filters?.orderBy:""
    };
    
    if (isHaveColFilter) {
      let colFilterOn = { ...pageFilter, filters: columnFilters };
      return onPageChange(colFilterOn, true, columnChangedFilters);
    }
    onPageChange(pageFilter);
  };

  const handlePageSizeChange = (e) => {
    
    const { value } = e.target;
    const pageFilter = {
      ...filters,
      currentPage: 1,
      pageSize: parseInt(value),
      order:sortKey,
orderBy:key?key:filters?.orderBy?filters?.orderBy:""
    };
    if (isHaveColFilter) {
      let colFilterOn = { ...pageFilter, filters: columnFilters };
      return onPageSizeChange(colFilterOn, true, columnChangedFilters);
    }
    onPageSizeChange(pageFilter);
  };

  return (
    <>
      {pageSize && (
        <Row className="justify-content-end py-2 ">
          <Col>
            <span className="text-dark f-14">Display</span>
            <Input
              type="select"
              onChange={handlePageSizeChange}
              bsSize="sm"
              className="display-select d-inline-block"
              value={pageSize}
              disabled={!data.length}
            >
              <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
            </Input>
            <span className="text-dark f-14 d-inline-block">records</span>
          </Col>
          <Col xs="auto">
            {hasColselect && (
              <Button
                size="sm"
                color="primary"
                className="ms-auto search"
                onClick={onSelectColoums}
                style={{ height: 35 }}
              >
                Column selector
              </Button>
            )}
          </Col>
          <Col xs="auto" className="ex_dropdown">
            {AllExport && hasExportPermission && (
              <UncontrolledDropdown group disabled={!data.length}>
                <Button
                  size="sm"
                  color="primary"
                  className="ms-auto search"
                  onClick={onExport}
                  disabled={!data.length}
                >
                  Export
                </Button>
                <DropdownToggle
                  className="ms-auto"
                  caret
                  color="primary"
                  size="sm"
                  outline
                  disabled={!data.length}
                />
                <DropdownMenu className="border-0 p-1 status-dropdown">
                  <DropdownItem onClick={AllExport}>All Columns</DropdownItem>
                  <DropdownItem onClick={slelectedExport} disabled={autoselectlist1.length == 0}>
                    Selected Columns
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            )}

            {onExport && hasExportPermission && (
              <Button
                size="sm"
                color="export"
                className="ms-auto"
                onClick={onExport}
                disabled={!data.length}
              >
                <span className="right_5">
                  <img src={ExportIcon} alt="" />
                </span>{" "}
                Export
              </Button>
            )}
            {datafilter == true ? (
              <></>
            ) : (
              <>
                <span className="ps-3 pe-2 f-13" style={{ fontWeight: "600" }} >Filter</span>
                <ButtonGroup className="filter-btn-group">
                  <Button
                    color="info"
                    outline
                    onClick={() => onClickFilter("off")}
                    active={rSelected === "off"}
                    disabled={!data.length}
                  >
                    OFF
                  </Button>
                  <Button
                    color="info"
                    outline
                    onClick={() => onClickFilter("on")}
                    active={rSelected === "on"}
                    disabled={!data.length}
                  >
                    ON
                  </Button>
                </ButtonGroup>
              </>
            )}
          </Col>
          {claims && (
            <Col xs="auto">
              <Dropdown className="nav_list-pre ms-2">
                <Button
                  size="sm"
                  color="export"
                  className="ms-auto"
                  style={{ border: "none", padding: "0" }}
                  // onClick={onExport}
                  disabled={filters.claimstatusIDs === undefined || (filters.claimstatusIDs && filters.claimstatusIDs.length > 1)}

                >
                  <Dropdown.Toggle variant="success" id="dropdown-basic">
                    <img src={threedots} alt="" />
                  </Dropdown.Toggle>
                </Button>

                <Dropdown.Menu>
                  <Dropdown.Item
                    href="#" style={{ padding: "8px 0", textAlign: "center" }}
                    onClick={onManualbulkUpdate}
                  // disabled={!data.length}
                  // disabled={!((selectedOpt.optSelected.length == 1) && (coveredEntityID) && (submit == true))}
                  >
                    <img src={ExportIcon} alt="" className="me-1" /> Bulk Update
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Col>
          )}
        </Row>
      )}
      <div
        className="rounded-table"
        ref={selectRef}
        id={id}
        onMouseLeave={handleMouseLeave}
        onMouseMove={handleMouseEnter}
      >
        {!loader && loading && <Loader opacity={0.01} color="black" />}
        {renderScrollArrowButtons()}
        <Table
          responsive
          id="reactstrap-table"
          className={`table table-striped theme-table ${fixedColumn && "fixed-column-table"
            }`}
          style={{ scrollBehavior: "smooth" }}
        >
          {headerRenderer()}
          <tbody>
            {colFilterEnable && columnFilters()}
            {renderRow()}
          </tbody>
        </Table>
      </div>
      {hasPagination && (
        <Pagination
          onPageChange={onHandlePageChange}
          currentPage={currentPage}
          totalRecords={totalRecords}
          pageSize={pageSize}
          hasNoEligibility={hasNoEligibility}
          researchNeededCount={researchNeededCount}
          eligibleCount={eligibleCount}
          inEligibleCount={inEligibleCount}
          data={data}
          rest={resetFlag}
        />
      )}
    </>
  );
};

export default ReactStrapTable;
